import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@mantine/core/styles.css'; // Import Mantine's core CSS
import '@mantine/notifications/styles.css'; // Import Notifications CSS
import { MantineProvider, createTheme } from '@mantine/core'; // Import the Mantine Provider and theme utility
import { Notifications } from '@mantine/notifications'; // For Toast/Snackbar replacement

// Define a custom theme to replicate your primary green color and general look
const theme = createTheme({
  primaryColor: 'green',
  colors: {
    // Customizing the green palette. 
    // Index 6 is the default "filled" button color.
    // Index 8/9 are often used for dark backgrounds (like Navbars).
    'green': [
      '#eef9f2', // 0
      '#daeedf', // 1
      '#b2d6bc', // 2
      '#87c09c', // 3
      '#60ac7e', // 4
      '#409968', // 5
      '#2E7D32', // 6 - Primary standard (Matches your image closely)
      '#26662e', // 7
      '#1E5924', // 8 - Darker shade for Navbar
      '#0f3115'  // 9
    ],
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* Wrap application in MantineProvider with the custom theme */}
    <MantineProvider theme={theme} defaultColorScheme="light"> 
      <Notifications position="top-right" /> {/* Add Notifications component for global alerts */}
      <App />
    </MantineProvider>
  </React.StrictMode>
);